module.exports = __webpack_public_path__ + "media/images/pharmacien-f482098bde569bdc580826ba1e4c7c47.png";